import { RenderElementProps } from "slate-react";
import { ImageElement } from "./ImageElement";
import { Mention } from "./Mention";
import { SafeLink } from "./SafeLink";
import { CSSProperties } from "react";

export interface ElementProps extends RenderElementProps {}

export const Element = (props: RenderElementProps) => {
  const { attributes, children, element } = props;
  const style: CSSProperties = { textAlign: element.align };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const parsedAttributes: any = Object.assign({}, attributes);
  const fontSize = parseInt(element.fontSize as string);
  // TODO: convert pt/rm into pixels?
  if (!isNaN(fontSize)) {
    style.fontSize = fontSize;
  }
  // for OL element
  if (element.start) {
    parsedAttributes.start = element.start;
  }

  // for OL or UL element
  if (element.listType) {
    parsedAttributes.type = element.listType;
  }

  if (element.color) {
    style.color = element.color;
  }

  if (element.margin) {
    style.margin = element.margin;
  }

  if (element.marginLeft) {
    style.marginLeft = element.marginLeft;
  }

  if (element.fontSize) {
    style.fontSize = element.fontSize;
  }

  if (element.background) {
    style.background = element.background;
  }

  switch (element.type) {
    case "paragraph":
      return (
        <p style={style} {...parsedAttributes}>
          {children}
        </p>
      );
    case "quote":
      return (
        <blockquote style={style} {...parsedAttributes}>
          {children}
        </blockquote>
      );
    case "code":
      return (
        <pre>
          <code style={style} {...parsedAttributes}>
            {children}
          </code>
        </pre>
      );
    case "ul":
      return (
        <ul style={style} {...parsedAttributes}>
          {children}
        </ul>
      );
    case "h1":
      return (
        <h1 style={style} {...parsedAttributes}>
          {children}
        </h1>
      );
    case "h2":
      return (
        <h2 style={style} {...parsedAttributes}>
          {children}
        </h2>
      );
    case "h3":
      return (
        <h3 style={style} {...parsedAttributes}>
          {children}
        </h3>
      );
    case "h4":
      return (
        <h4 style={style} {...parsedAttributes}>
          {children}
        </h4>
      );
    case "h5":
      return (
        <h5 style={style} {...parsedAttributes}>
          {children}
        </h5>
      );
    case "h6":
      return (
        <h6 style={style} {...parsedAttributes}>
          {children}
        </h6>
      );
    case "li":
      return (
        <li style={style} {...parsedAttributes}>
          {children}
        </li>
      );
    case "ol":
      return (
        <ol style={style} {...parsedAttributes}>
          {children}
        </ol>
      );
    case "link":
      return (
        <SafeLink href={element.url} {...parsedAttributes}>
          {children}
        </SafeLink>
      );
    case "img":
      return <ImageElement {...props} />;
    case "mention":
      return <Mention {...props} />;
    default:
      return (
        <span style={style} {...parsedAttributes}>
          {children}
        </span>
      );
  }
};
